import React, { useState, useCallback } from 'react';
import { Typography, Modal, ButtonIcon } from '@hpstellar/core/visId';
import { Share } from '@hpstellar/vis-icons';

import useCartState, { useCartActions } from '../../../hooks/useCartState';
import { Helpers } from '../../../core/src/helpers';
import withPageComponents from '../../../page/components/with-page-components';
import ErrorMessage from './error-messages';
import FreeGiftMessages from './free-gift-messages';
import MobileCheckoutContainer from './mobile-checkout-container';

import './cart-header.less';

// TODO: replace when GFE icon is available in vis-icons
const PrinterIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7.00244 7.00244H3.00244V16.9979H5.99564V16.0002H4.00017V8.00017H20.0002V16.0002L18.0002 16.0047V16.9934L20.9979 16.9979V7.00244H16.9979V3.00244H7.00244V7.00244ZM16.0002 7.00244H8.00017V4.00017H16.0002V7.00244ZM4.99972 9.49859L5.00244 10.0002H6.99791L7.00063 9.49859L7.00244 8.99791H4.99791L4.99972 9.49859ZM6.00017 13.0088C5.99745 13.0151 5.99655 13.2401 5.99745 13.5086L6.00017 13.9965L6.99791 14.0002L7.00244 20.9979H16.9979L17.0024 14.0002H17.9956V12.9979H12.0002C7.21197 12.9979 6.00289 13.0006 6.00017 13.0088ZM16.0002 20.0002H8.00017V17.0043C8.00017 15.3562 8.00289 14.0047 8.00652 14.002C8.00924 13.9984 9.80879 13.9965 12.0038 13.9975L15.9956 14.0002L16.0002 20.0002ZM8.99791 16.499H15.0024V15.5013H8.99791V16.499ZM9.00244 17.5077C8.99972 17.514 8.99881 17.7399 8.99972 18.0092L9.00244 18.499H14.9979V17.5013L12.002 17.4986C9.61015 17.4968 9.00516 17.4986 9.00244 17.5077Z" fill="#1A1A1A"/></svg>';

const HEADER_PROPS = {
    style: {
        borderBottom: 'none',
    },
};

const ShareCartButton = withPageComponents(
    ({ cartSettings, btnProps, modalProps }) => {
        const [open, setOpen] = useState(false);
        const { getShareCartLink } = useCartActions();
        const { shareCartIframe = 'https://cloud.store.hp.com/shareCart_new' } = cartSettings || {};

        const onIframeLoad = useCallback(e => {
            getShareCartLink().then(res => {
                const target = document.getElementById('shareCart');
                const { sCartResJson } = res || {};
                const { CartURL } = sCartResJson || {};
                if (CartURL && target) {
                    var message = JSON.stringify(sCartResJson);
                    if (target.contentWindow.postMessage) {
                        target.contentWindow.postMessage(message, '*');
                    }
                }
            });
        }, []);

        if (!shareCartIframe) {
            return null;
        }

        return (
            <div>
                <Modal
                    className="share-cart-modal"
                    isOpen={open}
                    onClose={() => setOpen(false)}
                    {...(modalProps || {})}
                >
                    <iframe id="shareCart" src={shareCartIframe} height={630} onLoad={onIframeLoad} />
                </Modal>
                <ButtonIcon {...btnProps} icon={<Share size="m" />} hasBorder={false} onClick={() => setOpen(true)} />
            </div>
        );
    },
    { components: ['cartSettings'] },
);

const ShareCart = ({ deleteAllButton }) => (
    <div className="share-cart">
        <ShareCartButton
            btnProps={{
                className: 'share-cart-button',
                children: 'Share Cart',
            }}
            modalProps={{ size: 'lg', headerProps: HEADER_PROPS }}
        />
        <div className="divider" />
        <ButtonIcon
            icon={<span className="cartIcon" dangerouslySetInnerHTML={{ __html: PrinterIcon }} />}
            className="share-cart-button print-cart-button"
            hasBorder={false}
            onClick={() => window.print()}
        >
            Print Cart
        </ButtonIcon>
        {deleteAllButton && (
            <>
                <div className="divider" />
                {deleteAllButton}
            </>
        )}
    </div>
);

export default ({ title = 'Your Cart', deleteAllButton }) => {
    const { cartInfo, emptyCart } = useCartState();
    const { cartView, tQty: itemCount } = cartInfo || {};
    const { orderItem = [], grandTotal, x_isExchangeOrder } = cartView || {};
    const cartTitle = x_isExchangeOrder === 'true' ? 'Your Exchange Cart' : title;

    return (
        <div className="cart-header">
            <div className="title-row">
                <Typography variant="h4" className={`cart-title${emptyCart ? ' empty-cart' : ''}`}>
                    {cartTitle}
                    {itemCount > 0 && (
                        <Typography
                            variant="body1"
                            tag="span"
                            className="cart-item-count"
                        >{`${itemCount} item${itemCount > 1 ? 's' : ''}`}</Typography>
                    )}
                </Typography>
                {itemCount > 0 && <ShareCart deleteAllButton={deleteAllButton} />}
            </div>
            {grandTotal * 1 > 0 && !emptyCart && (
                <div className="total-price">
                    <Typography>Total:</Typography>
                    <Typography weight={700}>{Helpers.formatCurrency(grandTotal, undefined, true)}</Typography>
                </div>
            )}
            {itemCount > 0 && <MobileCheckoutContainer />}
            <FreeGiftMessages />
            <ErrorMessage />
        </div>
    );
};
